// @flow

/* eslint-disable ta-code-conventions/has-matching-storydoc, ta-code-conventions/has-matching-test */

import Logging from '@ta/common.logging';
import type { Fetcher, FetcherResults } from '@ta/common.typeahead';

type RecentlyViewedType =
  | 'all'
  | 'searches'
  | 'locations'
  | 'attractions'
  | 'attraction_products'
  | 'hotels'
  | 'restaurants'
  | 'airports'
  | 'airlines'
  | 'cruise_lines'
  | 'vr'
  | 'neighborhoods'
  | 'location_group'
  | 'geos'
  | 'hotel_searches'
  | 'flight_searches';

type Props = {|
  /** Categories to include */
  categories?: Array<RecentlyViewedType>,

  /** The maximum number of results to include (defaults to 10) */
  limit?: number,
|};

/** The fetcher ID */
export const ID = 'recentlyviewed';

/**
 * A typeahead fetcher for recently viewed
 */
class RecentlyViewedFetcher implements Fetcher {
  id: string = ID;
  categories: Array<RecentlyViewedType>;
  limit: number = 10;
  results: FetcherResults = null;
  inFlight: boolean = false;

  constructor({ categories, limit }: Props) {
    if (categories) {
      this.categories = categories;
    }
    if (limit) {
      this.limit = limit;
    }
  }

  getResults(): FetcherResults {
    return this.results;
  }

  fetch(term: string, context: ?{ [string]: any }, onChange: () => mixed): void {
    // we don't actually care about the term here. It should be the same result regardless so only fetch once and ignore
    // multiple requests
    if (this.inFlight || this.results !== null) {
      return;
    }

    const params = new URLSearchParams({
      limit: String(this.limit),
    });

    if (this.categories) {
      this.categories.forEach(c => params.append('categories[]', c));
    }

    this.inFlight = true;
    fetch(`/data/1.0/recent?${params.toString()}`, {
      method: 'GET',
      credentials: 'same-origin',
    })
      .then(response => {
        if (response.ok) {
          return response;
        }
        throw Error(response.statusText);
      })
      .then(response => response.json())
      .then(results => {
        this.results = results.data.map(d => ({ resultType: d.result_type, ...d.result_object }));
        this.inFlight = false;
        onChange();
      })
      .catch(error => {
        Logging.error('recentPrefill', error);
        this.results = [];
        this.inFlight = false;
        onChange();
      });
  }
}

export default RecentlyViewedFetcher;
